import { setItem } from '@utils/persistanceStorage'
import axios, { AxiosResponse } from 'axios'
import { getItem } from '@/utils/persistanceStorage'
import { TokenModel } from '@/core/services/Token/model/TokenModel'

const baseURLApi = process.env.REACT_APP_API_URL
// const baseURL = process.env.REACT_APP_BASE_URL

const axiosApiInstance = axios.create({ baseURL: baseURLApi })

const refreshAccessToken = async (): Promise<TokenModel | null> => {
  const token: TokenModel | null = getItem('token') || null
  const res = await axios.post<null, AxiosResponse<TokenModel, null>>(
    `${baseURLApi}/Auth/RefreshTokens`,
    null,
    {
      headers: {
        Authorization: `Bearer ${token?.refresh_token}`,
        ContentType: 'application/json',
      },
    },
  )

  if (res.data && res.data) {
    setItem('token', res.data)
    return res.data
  }

  return null
}

axiosApiInstance.interceptors.request.use(async config => {
  const token: TokenModel | null = getItem('token') || null
  const authorizationToken = token ? `Bearer ${token.access_token}` : ''
  // if (
  //   (config && config.headers && config.method === 'POST') ||
  //   config.method === 'PATCH' ||
  //   config.method === 'PUT'
  // ) {
  //   config.headers = {
  //     'Content-Type': 'application/json;charset=utf-8',
  //   }
  // }

  if (config && config.headers) {
    config.headers = {
      Authorization: authorizationToken,
      'Content-Type': 'application/json;charset=utf-8',
    }
  }

  return config
})

axiosApiInstance.interceptors.response.use(
  response => {
    return response
  },
  async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      await refreshAccessToken()

      // axiosApiInstance.defaults.headers.common['Authorization'] =
      //   'Bearer ' + token?.access_token
      // axiosApiInstance.defaults.headers.common['Content-Type'] =
      //   'application/json;charset=utf-8'

      return axiosApiInstance(originalRequest)
    }
    return Promise.reject(error)
  },
)

export default axiosApiInstance
